import { useEffect } from 'react'

import { trackExperimentViewed } from '@mc/track-event'

export const I18N_PRICING_FLAG_NAME = 'com-1475_v1'

export const trackI18nPricingViewed = () =>
  trackExperimentViewed(I18N_PRICING_FLAG_NAME)

export const useTrackI18nPricingViewed = () => {
  useEffect(() => {
    trackI18nPricingViewed()
  }, [])
}
